'use client';

import _defineProperty from "/codebuild/output/src176/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src176/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "style", "vars", "children", "onKeyDownCapture", "variant", "classNames", "styles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, jsxs } from 'react/jsx-runtime';
import { useFocusReturn, useMergedRef } from '@mantine/hooks';
import { rem } from '../../../core/utils/units-converters/rem.mjs';
import 'react';
import { closeOnEscape } from '../../../core/utils/close-on-escape/close-on-escape.mjs';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../../core/MantineProvider/use-props/use-props.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import { factory } from '../../../core/factory/factory.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import '@floating-ui/react';
import { FloatingArrow } from '../../Floating/FloatingArrow/FloatingArrow.mjs';
import { FocusTrap } from '../../FocusTrap/FocusTrap.mjs';
import '../../Portal/Portal.mjs';
import { OptionalPortal } from '../../Portal/OptionalPortal.mjs';
import '../../Transition/transitions.mjs';
import { Transition } from '../../Transition/Transition.mjs';
import { usePopoverContext } from '../Popover.context.mjs';
import classes from '../Popover.module.css.mjs';
var defaultProps = {};
var PopoverDropdown = factory(function (_props, ref) {
  var _ctx$transitionProps, _ctx$transitionProps$, _ctx$transitionProps2, _ctx$transitionProps3, _ctx$transitionProps4;
  var props = useProps("PopoverDropdown", defaultProps, _props);
  var className = props.className,
    style = props.style,
    vars = props.vars,
    _children = props.children,
    onKeyDownCapture = props.onKeyDownCapture,
    variant = props.variant,
    classNames = props.classNames,
    styles = props.styles,
    others = _objectWithoutProperties(props, _excluded);
  var ctx = usePopoverContext();
  var returnFocus = useFocusReturn({
    opened: ctx.opened,
    shouldReturnFocus: ctx.returnFocus
  });
  var accessibleProps = ctx.withRoles ? {
    "aria-labelledby": ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {};
  var mergedRef = useMergedRef(ref, ctx.floating);
  if (ctx.disabled) {
    return null;
  }
  return /* @__PURE__ */jsx(OptionalPortal, _objectSpread(_objectSpread({}, ctx.portalProps), {}, {
    withinPortal: ctx.withinPortal,
    children: /* @__PURE__ */jsx(Transition, _objectSpread(_objectSpread({
      mounted: ctx.opened
    }, ctx.transitionProps), {}, {
      transition: ((_ctx$transitionProps = ctx.transitionProps) === null || _ctx$transitionProps === void 0 ? void 0 : _ctx$transitionProps.transition) || "fade",
      duration: (_ctx$transitionProps$ = (_ctx$transitionProps2 = ctx.transitionProps) === null || _ctx$transitionProps2 === void 0 ? void 0 : _ctx$transitionProps2.duration) !== null && _ctx$transitionProps$ !== void 0 ? _ctx$transitionProps$ : 150,
      keepMounted: ctx.keepMounted,
      exitDuration: typeof ((_ctx$transitionProps3 = ctx.transitionProps) === null || _ctx$transitionProps3 === void 0 ? void 0 : _ctx$transitionProps3.exitDuration) === "number" ? ctx.transitionProps.exitDuration : (_ctx$transitionProps4 = ctx.transitionProps) === null || _ctx$transitionProps4 === void 0 ? void 0 : _ctx$transitionProps4.duration,
      children: function children(transitionStyles) {
        var _ctx$y, _ctx$x;
        return /* @__PURE__ */jsx(FocusTrap, {
          active: ctx.trapFocus,
          innerRef: mergedRef,
          children: /* @__PURE__ */jsxs(Box, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, accessibleProps), others), {}, {
            variant: variant,
            onKeyDownCapture: closeOnEscape(ctx.onClose, {
              active: ctx.closeOnEscape,
              onTrigger: returnFocus,
              onKeyDown: onKeyDownCapture
            }),
            "data-position": ctx.placement,
            "data-fixed": ctx.floatingStrategy === "fixed" || void 0
          }, ctx.getStyles("dropdown", {
            className: className,
            props: props,
            classNames: classNames,
            styles: styles,
            style: [_objectSpread(_objectSpread({}, transitionStyles), {}, {
              zIndex: ctx.zIndex,
              top: (_ctx$y = ctx.y) !== null && _ctx$y !== void 0 ? _ctx$y : 0,
              left: (_ctx$x = ctx.x) !== null && _ctx$x !== void 0 ? _ctx$x : 0,
              width: ctx.width === "target" ? void 0 : rem(ctx.width)
            }), style]
          })), {}, {
            children: [_children, /* @__PURE__ */jsx(FloatingArrow, _objectSpread({
              ref: ctx.arrowRef,
              arrowX: ctx.arrowX,
              arrowY: ctx.arrowY,
              visible: ctx.withArrow,
              position: ctx.placement,
              arrowSize: ctx.arrowSize,
              arrowRadius: ctx.arrowRadius,
              arrowOffset: ctx.arrowOffset,
              arrowPosition: ctx.arrowPosition
            }, ctx.getStyles("arrow", {
              props: props,
              classNames: classNames,
              styles: styles
            })))]
          }))
        });
      }
    }))
  }));
});
PopoverDropdown.classes = classes;
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";
export { PopoverDropdown };